import { AuthenticationMethodApiModel } from './Models/General/AuthenticationMethodApiModel';
import { SignatureDocuments } from './Models/Client/SignatureDocuments';
import { EventEmitter, Injectable } from '@angular/core';
import { ComplianceSettings } from './api/v2/notificationSettings.service';
import { IdentityApiModel } from './api/v2/Models/IdentityApiModel';
import { OpenTargetWith } from '../Components/Authentication/signin.component';

@Injectable()
export class SpaEventService {
	//
	onUpdateMenu = new EventEmitter<void>();

	// AppointmentEvents
	onCallEnded = new EventEmitter<void>();

	// Sign events
	onSignInRequired = new EventEmitter<{
		target: string;
		reason?: string;
		error?: string;
		leave?: boolean;
		callticket?: Guid;
		authMethod?: AuthenticationMethodApiModel;
		openTargetWith?: OpenTargetWith;
	}>();
	onSignedIn = new EventEmitter<IdentityApiModel>();
	onSignedInAsOutsider = new EventEmitter<boolean>(); //  Bool overrideRequireLogin
	onSignedOut = new EventEmitter<{
		redirectUrl?: string | null;
	}>();
	onSignedOutAsOutsider = new EventEmitter<{
		redirectUrl?: string | null;
		reloadAfterSignOut?: boolean;
	}>();
	onSignInAborted = new EventEmitter<void>();
	onSigningIn = new EventEmitter<void>();

	// Signatures
	onDocumentsSigningNeeded = new EventEmitter<SignatureDocuments>();
	onDocumentsSigningCompleted = new EventEmitter<void>();
	onDocumentsSigningAborted = new EventEmitter<void>();

	// NotificationCompliance
	onNotificationComplianceNeeded = new EventEmitter<ComplianceSettings>();
	onNotificationComplianceConfirmation = new EventEmitter<ComplianceSettings & { onCancel: () => void }>();
	onNotificationComplianceCompleted = new EventEmitter<void>();

	// Registration events
	onRegistrationAborted = new EventEmitter<void>();
	onVisitorRegistred = new EventEmitter<void>();
	onRegistrationRequired = new EventEmitter<{ target: string; ticket: Guid }>();

	// Unit events
	onChangeUnit = new EventEmitter<{ unitId: number }>();
}
